<template>
  <div class="container-header-features-val">
    <div class="col-header-feature col-header-feature--typo">
      <div class="feature--title">{{ $t("typology") }}</div>
      <div class="feature--value">{{ $t(getTypoLiteral(exportedData.valuationSave.valuation.tiposelector)) }}</div>
    </div>
    <div class="col-header-feature col-header-feature--typo">
      <div class="feature--title">{{ $t("valuationFilters.features") }}</div>
      <div class="feature--value feature--value__icons">
        <div>
          <img :src="getIconSrc('bed')" alt="img">
          <sub v-if="exportedData !== null && exportedData !== undefined">{{ exportedData.valuationSave.valuation.bed }}</sub>
        </div>
        <div>
          <img :src="getIconSrc('bath')" alt="img">
          <sub v-if="exportedData !== null && exportedData !== undefined">{{ exportedData.valuationSave.valuation.bath }}</sub>
        </div>
        <div>
          <img :src="getIconSrc('lift')" alt="img">
          <sub v-if="exportedData !== null && exportedData !== undefined">{{ exportedData.valuationSave.valuation.lift }}</sub>
        </div>
        <div>
          <img :src="getIconSrc('parking')" alt="img">
          <sub v-if="exportedData !== null && exportedData !== undefined">{{ exportedData.valuationSave.valuation.parking }}</sub>
        </div>
        <div>
          <img :src="getIconSrc('trastero')" alt="img">
          <sub v-if="exportedData !== null && exportedData !== undefined">{{ exportedData.valuationSave.valuation.trastero }}</sub>
        </div>
        <div>
          <img :src="getIconSrc('pool')" alt="img">
          <sub v-if="exportedData !== null && exportedData !== undefined">{{ exportedData.valuationSave.valuation.pool }}</sub>
        </div>
      </div>
    </div>
    <div class="col-header-feature col-header-feature--typo">
      <div class="feature--title">{{ $t("valuationFilters.const-year") }}</div>
      <div v-if="exportedData !== null && exportedData !== undefined" class="feature--value">{{ separadorMilesCast(exportedData.valuationSave.valuation.builtyear) }}</div>
    </div>
    <div class="col-header-feature col-header-feature--typo">
      <div class="feature--title">{{ $t("floor") }}</div>
      <div v-if="exportedData !== null && exportedData !== undefined" class="feature--value">{{ exportedData.valuationSave.valuation.floor }}</div>
    </div>
    <div class="col-header-feature col-header-feature--typo">
      <div class="feature--title">{{ $t("valued-surface") }}</div>
      <div v-if="exportedData !== null && exportedData !== undefined" class="feature--value">
        {{ separadorMilesCast(exportedData.valuationSave.valuation.surface) }} {{ $t("sqm") }}
      </div>
    </div>
    <div class="col-header-feature col-header-feature--typo">
      <div class="feature--title">{{ $t("value") }}</div>
      <div class="feature--value feature--value__columns">
        <div v-if="exportedData !== null && exportedData !== undefined" class="feature-value--col">
          {{ exportedData.valuationSave.valuation.esqm.toLocaleString("it-IT", { minimumFractionDigits: 0, maximumFractionDigits: 0 }) }} {{ $t("esqm") }}
        </div>
        <div v-if="exportedData !== null && exportedData !== undefined" class="feature-value--col">
          {{ separadorMilesCast(exportedData.valuationSave.valuation.salevalue) }} €
        </div>
      </div>
    </div>
    <div class="col-header-feature col-header-feature--typo">
      <div class="feature--title">{{ $t("days-to-sell") }}</div>
      <div v-if="exportedData !== null && exportedData !== undefined" class="feature--value">{{ exportedData.valuationSave.valuation.daysToSell }}</div>
    </div>
  </div>
</template>

<script>
import { separadorMiles } from '@/utils/chartutils'

export default {
  name: 'PageHeaderContent',
  components: {},
  props: {},
  data() {
    return {}
  },
  computed: {
    /**
     * Se cargan los datos para pintar en la vista del PDF
     */
    exportedData() {
      return JSON.parse(localStorage.getItem('data_export_val')) || ''
    }
  },
  watch: {},
  mounted: function() {},

  methods: {
    separadorMilesCast(string) {
      return separadorMiles(string)
    },
    getIconSrc(tipo) {
      switch (tipo) {
        case 'bed':
          return this.bed > 0 ? require('@/assets/brains_icons/bedon.png') : require('@/assets/brains_icons/bedoff.png')
        case 'bath':
          return this.bath > 0 ? require('@/assets/brains_icons/bathon.png') : require('@/assets/brains_icons/bathoff.png')
        case 'parking':
          return this.parking > 0 ? require('@/assets/brains_icons/parkingon.png') : require('@/assets/brains_icons/parkingoff.png')
        case 'trastero':
          return this.trastero > 0 ? require('@/assets/brains_icons/trasteroon.png') : require('@/assets/brains_icons/trasterooff.png')
        case 'lift':
          return this.lift > 0 ? require('@/assets/brains_icons/lifton.png') : require('@/assets/brains_icons/liftoff.png')
        case 'pool':
          return this.pool > 0 ? require('@/assets/brains_icons/poolon.png') : require('@/assets/brains_icons/pooloff.png')
      }
    },
    getTypoLiteral(tipo) {
      switch (tipo) {
        case 'flat':
          return 'valuationFilters.flat'
        case 'house':
          return 'valuationFilters.house'
        case 'retail':
          return 'dataSelectors.retail'
        case 'office':
          return 'dataSelectors.office'
        case 'industrial':
          return 'dataSelectors.industrial'
        case 'landplot':
          return 'dataSelectors.land-plot'
        case 'hospitality':
          return 'dataSelectors.hospitality'
        case 'parking':
          return 'valuationFilters.parking'
        case 'storage':
          return 'valuationFilters.storage'
        case 'other':
          return 'dataSelectors.other'
        default:
          return tipo
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container-header-features-val {
  width: 100%;
  background-color: rgb(240, 240, 240);
  height: 100%;
  display: grid;
  grid-template-columns: 100px 300px 100px 100px 400px 300px 100px; // 1400 (160)
  padding: 15px;
  gap: 22px; // 1560

  .col-header-feature {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 15px;

    .feature--value {
      font-weight: 600;
    }

    .feature--value__columns {
      display: flex;
      justify-content: flex-start;
      gap: 35px;
    }

    .feature--value__icons {
      display: flex;
      justify-content: flex-start;
      gap: 20px;

      div sub {
        font-size: 13px;
        margin-left: 4px;
        color: rgb(194, 194, 194);
      }
    }
  }
}
</style>
